export enum ProductTypes {
  FRAME = 'frame',
  SAVINGS_PLAN = 'savings_plans',
  CONTACT_LENS = 'contact_lenses',
}

export enum ChildrenLineItems {
  LENSES = 'lenses',
  LENSES_TREATMENT = 'lenses_treatment'
}

export enum Attributes {
  BRAND_FRIENDLY = 'BRAND_FRIENDLY',
  STYLE_NAME = 'STYLE_NAME',
  NAME_FRIENDLY = 'NAME_FRIENDLY',
  COLOR = 'COLOR',
  LENS_TYPE = 'LENS_TYPE',
  LENS_SEG_STYLE_FRIENDLY = 'LENS_SEG_STYLE_FRIENDLY',
  LENS_SEG_STYLE_COST = 'LENS_SEG_STYLE_COST',
  LENS_MATERIAL_FRIENDLY = 'LENS_MATERIAL_FRIENDLY',
  LENS_MATERIAL_COST = 'LENS_MATERIAL_COST',
  TREATMENT_TYPE_GROUP = 'TREATMENT_TYPE_GROUP',
  ITEM_REFERENCE = 'ITEM_REFERENCE',
  IS_AVAILABLE = 'IS_AVAILABLE',
  COAT = 'coat',
  TINT = 'tint',
  WEB_ENABLED = 'WEB_ENABLED',
}

export const LensAttributes = [
  'LENS_TYPE',
  'LENS_SEG_STYLE_FRIENDLY',
  'LENS_SEG_STYLE_COST',
  'LENS_MATERIAL_FRIENDLY',
  'LENS_MATERIAL_COST',
]

export enum ChildItemLabels {
  COLOR = 'productLineItem.color.lbl',
  PRESCRIPTION = 'productLineItem.prescription.lbl',
  MATERIAL = 'productLineItem.material.lbl',
  COAT = 'productLineItem.coat.lbl',
  ENHANCEMENTS = 'productLineItem.enhancements.lbl',
}

export enum ChildItemOrder {
  COLOR,
  PRESCRIPTION,
  MATERIAL,
  COAT,
  ENHANCEMENTS,
}
